import {connect} from "react-redux";
import ProceedToPaymentButton from "./../component/ProceedToPaymentButton";
import {validateForm} from "../actions";

const mapDispatchToProps = dispatch => {
    return {
        onClick: () => {
            const formElements = document.getElementById("order_form").elements;
            let formData = {};
            Object.keys(formElements).map((i) => {
                formData[formElements[i].name] = formElements[i].value
            })

            dispatch(validateForm(formData))
        },
    }
}

const ProceedToPaymentContainer = connect(
    null,
    mapDispatchToProps
)(ProceedToPaymentButton)

export default ProceedToPaymentContainer